import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { saveAs as importedSaveAs } from 'file-saver';

export interface ProfessionalData {
  id: string;
  fullname: string;
  identity: string;
  document: string;
  pis: string;
  numberHealth: string;
  bloodType: string;
  dateOfBirth: string;
  licenseNumber: string;
  neighborhood: string;
  street: string;
  locale: string;
  zipcode: string;
  number: string;
  complement: string;
  cellphone: string;
  phone: string;
  email: string;
  status: string;
  employmentType: string;
  isActive: boolean;
  civilStatus: string;
}

export interface ReportField {
  key: string;
  header: string;
  width: number;
  selected: boolean;
}

export interface ProfessionalsResponse {
  professionals: ProfessionalData[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProfessionalReportService {

  constructor(private http: HttpClient) {}

  getProfessionalsData(status?: string, isActive?: string, employmentType?: string): Observable<ProfessionalsResponse> {
    const params: string[] = [];
    if (status && status !== 'ALL') params.push(`status=${status}`);
    if (isActive !== undefined && isActive !== 'ALL') params.push(`isActive=${isActive}`);
    if (employmentType && employmentType !== 'ALL') params.push(`employmentType=${employmentType}`);
    const query = params.length ? `?${params.join('&')}` : '';
    return this.http.get<ProfessionalsResponse>(environment.apiUrl + `admin/professionals/reports/data${query}`);
  }

  getAvailableFields(): ReportField[] {
    return [
      { key: 'fullname', header: 'Nome', width: 40, selected: true },
      { key: 'identity', header: 'RG', width: 15, selected: true },
      { key: 'document', header: 'CPF', width: 15, selected: true },
      { key: 'pis', header: 'PIS', width: 25, selected: false },
      { key: 'numberHealth', header: 'Nº Cartão SUS', width: 20, selected: false },
      { key: 'bloodType', header: 'Tipo Sanguineo', width: 20, selected: false },
      { key: 'dateOfBirth', header: 'Data de Nascimento', width: 15, selected: true },
      { key: 'licenseNumber', header: 'Nº conselho', width: 15, selected: true },
      { key: 'neighborhood', header: 'Bairro', width: 25, selected: true },
      { key: 'street', header: 'Logradouro', width: 25, selected: true },
      { key: 'locale', header: 'Localidade/UF', width: 15, selected: true },
      { key: 'zipcode', header: 'CEP', width: 15, selected: false },
      { key: 'number', header: 'Nº casa', width: 15, selected: false },
      { key: 'complement', header: 'Complemento', width: 35, selected: false },
      { key: 'cellphone', header: 'Celular', width: 15, selected: true },
      { key: 'phone', header: 'Telefone', width: 15, selected: false },
      { key: 'email', header: 'Email', width: 15, selected: true },
      { key: 'status', header: 'Status', width: 15, selected: true },
      { key: 'employmentType', header: 'Vínculo Trabalhista', width: 22, selected: false },
      { key: 'isActive', header: 'Ativo', width: 10, selected: false },
      { key: 'civilStatus', header: 'Estado Civil', width: 15, selected: false },
    ];
  }

  generateCustomSpreadsheet(selectedFields: string[], filters?: any) {
    return this.http
      .post(environment.apiUrl + 'admin/professionals/reports/custom-spreadsheet',
        { selectedFields, filters },
        { responseType: 'blob' }
      )
      .pipe(map((result: Blob) => {
        importedSaveAs(result, 'custom-professionals-report.xlsx');
        return result;
      }));
  }

  generateSpreadsheet() {
    return this.http
      .get(environment.apiUrl + `admin/professionals/reports/spreadsheet`, { responseType: 'blob' })
      .pipe(map((result: Blob) => {
        importedSaveAs(result, 'professionals-report.xlsx');

        return result;
      }));
  }
}
